// react imports
import React, { useContext, useState, useEffect } from "react";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

// CUSTOM COMPONENTS IMPORTS
import AppContext from '../../../AppContext';
import SellerCard from "../../common/seller-card/SellerCard";
import ProductListItem from "../../common/product-list/product-list-item/ProductListItem";
import RatingsModal from "../../modals/ratings-modal/RatingsModal";
import EmptyTab from "../EmptyTab/EmptyTab";

// MODAL IMPORTS
import BookmarkOnlyModal from "../../modals/bookmark-only-modal/BookmarkOnlyModal";

// DATA IMPORT
import { Seller as seller, SampleProducts, UserRatings } from "../../../data/product-data";
import { Users } from "../../../data/user-data";

// MULTILANGUAGE
import { withTranslation, Trans } from 'react-i18next';
import i18next from 'i18next';
import i18n from '../../../i18n';
import ReportModal from "../../modals/report-modal/ReportModal";

// IMAGE IMPORT
import userImage from '../../../images/user.png';

import Moment from 'moment';
import MessageModal from "../../modals/message-modal/MessageModal";
import MessageSendModal from "../../modals/message-send-modal/MessageSendModal";
import MessageDeleteModal from "../../modals/message-delete-modal/MessageDeleteModal";

const messagesModel = [];

for (let i = 1; i < 11; i++) {
  messagesModel.push({
    id: i,
    partner: {
      id: 0,
      image: {
        id: 0,
        url: userImage
      },
      publicName: 'Robert Smith',
    },
    timestamp: new Date('2023.07.19 18:00'),
    itemName: 'Sunglasses',
    textStart: 'Lorem ipsum',
    unread: i < 4
  })
}

const MessagesPage = (props) => {
  const context = useContext(AppContext);

  // STATES
  const [incomingMessages, setIncomingMessages] = useState([]);
  const [sentMessages, setSentMessages] = useState([]);
  const [selectedTab, setSelectedTab] = useState('Inbox'); // INBOX or SENT

  // MODAL STATES
  const [idMessageModal, setIdMessageModal] = useState();
  const [messageSendModalVisible, setMessageSendModalVisible] = useState(false);
  const [messageSendModalRecipient, setMessageSendModalRecipient] = useState();
  const [messageSendModalSubject, setMessageSendModalSubject] = useState();
  const [messageSendModalOrderId, setMessageSendModalOrderId] = useState();

  const [idDeleteMessageModal, setIdDeleteMessageModal] = useState();

  // MULTILANGUAGE
  const { t } = i18n;

  const loadNewProductsSell = () => {
    setLoadingNewProductsSell(true);
    setTimeout(() => {
      setPageSizeSell(pageSizeSell + 20),
      context.onRenderTrue();
      setLoadingNewProductsSell(false);
    }, 500);
  };
  const loadNewProductsBought = () => {
    setLoadingNewProductsBought(true);
    setTimeout(() => {
      setPageSizeBought(pageSizeBought + 20),
      context.onRenderTrue();
      setLoadingNewProductsBought(false);
    }, 500);
  };
  const loadNewProductsSold = () => {
    setLoadingNewProductsSold(true);
    setTimeout(() => {
      setPageSizeSold(pageSizeSold + 20),
      context.onRenderTrue();
      setLoadingNewProductsSold(false);
    }, 500);
  };

  // TEMPLATE
  const getMessageTemplate = (message, n, text) => {
    return (
      <div 
        className={"email" + (message?.status === "NEW" ? ' unread' : '')}
        key={n}
        onClick={() => setIdMessageModal(message?.id)}
      >
        <i className={`${message?.status === "NEW" ? 'fa-solid' : 'fa-regular'} fa-envelope`}></i>
        <img 
          src={message?.partner.image?.url ? message?.partner.image?.url : userImage} 
          alt={message?.partner?.publicName}
        />
        <div className="subject-and-from">
          <div className="subject">{message?.itemName} </div>
          <div className="from"> <span>{text}</span> {message?.partner?.publicName}</div>
        </div>

        {message?.sentAt && (
          <div className="date">
            {Moment(message?.sentAt).format('DD.MM.YYYY HH:mm')}
          </div>
        )}
      </div>
    );
  };
  

  // TESTING
  // useState(() => {
  //   setMessageSendModalRecipient({ id: 13, publicName: 'John Doe' });
  //   setMessageSendModalSubject('Sunglasses');
  //   setMessageSendModalOrderId(3020);

  //   setMessageSendModalVisible(true);
  // }, []);

  //EVENTS

  const onDeleteMessageById = (id) => {
    context.interAxios.delete('/message/' + id, function(response) {
    })
  }


  useEffect(() => {
    context.interAxios.get('/message/inbox', function(response) {
      setIncomingMessages(response.data)
      
    })
    context.interAxios.get('/message/sent', function(response) {
      setSentMessages(response.data)
      
    })
  }, []);
  

  return (
    <div className="jc-page white messages">
      <div className="container-fluid mw-1300">
        <h1>Messages</h1>

        <div className="jc-tabs tabs-2">
          <div
            className={"jc-tab" + (selectedTab === 'Inbox' ? ' active' : '')}
            onClick={() => setSelectedTab('Inbox')}
          >
            <i className="fa-solid fa-inbox-in"></i>
            {t('messages.inbox')}
          </div>
          <div
            className={"jc-tab" + (selectedTab === 'Sent' ? ' active' : '')}
            onClick={() => setSelectedTab('Sent')}
          >
            <i className="fa-solid fa-inbox-out"></i>
            {t('messages.sent')}
          </div>
        </div>

        {(selectedTab === 'Inbox') && (
          <>
            <div className="email-list inbox unread">
              {incomingMessages.map((m, n) => getMessageTemplate(m, n, "From:"))}
            </div>
          </>
        )}

        {(selectedTab === 'Sent') && (
          <>
            <div className="email-list inbox unread">
              {sentMessages.map((m, n) => getMessageTemplate(m, n, "To:"))}
            </div>
          </>
        )}
      </div>

      <MessageModal
        messageId={idMessageModal}
        hideModal={() => setIdMessageModal(null)}
        reply={(orderId, recipientId, recipientPublicName, subject) => {
          setIdMessageModal(null);
          setTimeout(() => {
            setMessageSendModalRecipient({ id: recipientId, publicName: recipientPublicName });
            setMessageSendModalSubject(subject);
            setMessageSendModalOrderId(orderId);
            
            setMessageSendModalVisible(true);
          }, 500);
        }}
        delete={(messageId) => {
          setIdMessageModal(null);
          onDeleteMessageById(messageId)
          setTimeout(() => {
            setIdDeleteMessageModal(messageId);
          }, 500);
        }}
      />

      <MessageSendModal
        visible={messageSendModalVisible}
        hideModal={() => setMessageSendModalVisible(false)}
        recipient={messageSendModalRecipient}
        subject={messageSendModalSubject}
        orderId={messageSendModalOrderId}
      />

      <MessageDeleteModal
        messageId={idDeleteMessageModal}
        hideModal={() => setIdDeleteMessageModal(null)}
      />

    </div>
  );
};

export default withTranslation()(MessagesPage);
